import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { IStatus } from "../../../interfaces/IStatus.tsx";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import { IMember } from "../../../interfaces/IMember.tsx";
import './Status.css'
import { hoursList } from "../../../StaticData.tsx";

import {
  Button,
  Form,
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useNotification } from "../../../hooks/useNotification";

function StatusEdit() {
  //#region Hooks
  const { notify } = useNotification();
  const {
    createStatus,
    updateStatus,
    detailStatus,
    deleteStatus,
    getAllStatus,
    getMemberActionByStatus,
    getBoardMembers,
    calculateMemberActionsChange,
    updateMembersActions,
  } = useApiRequests();
  const navigate = useNavigate();
  //#endregion

  const { id } = useParams();
  const [allStatus, setAllStatus] = useState<IStatus[]>([]);

  const [status, setStatus] = useState<IStatus>();
  const [emailsString, setEmailsString] = useState<string>("");
  const [emailsInerciaString, setEmailsInerciaString] = useState<string>("");
  const [emailsTasksAccumulationString, setEmailsTasksAccumulationString] = useState<string>("");
  const [actionsForStatus, setActionsForStatus] = useState<any>(null);
  const [members, setMembers] = useState<any>(null);




  //#region useEffet
  useEffect(() => {
    if (id !== "new") {
      getStatus();
      getActionsByStatus();
      getMembers();
    }

    fetchAllStatus();
  }, []);

  useEffect(() => {
    if (emailsString !== null) {
      const listOfEmails = emailsString.split(";");
      setStatus({
        ...status,
        internalEmailsToNotify: listOfEmails,
      });
    }
  }, [emailsString]);

  useEffect(() => {
    if (emailsInerciaString !== null) {
      const listOfInertiaEmails = emailsInerciaString.split(";");
      setStatus({
        ...status,
        inertiaEmails: listOfInertiaEmails,
      });
    }
  }, [emailsInerciaString]);

  useEffect(() => {
    if (emailsTasksAccumulationString !== null) {
      const tasksAccumulationEmails = emailsTasksAccumulationString.split(";");
      setStatus({
        ...status,
        tasksAccumulationEmails: tasksAccumulationEmails ,
      });
    }
  }, [emailsTasksAccumulationString]);

  //#endregion

  //#region Logic

  const getMembers = async () => {
    const data = await getBoardMembers();
    if (data.success) {
      const dataParsed = JSON.parse(data.data);
      const dataFiltered = dataParsed.filter((element) => {
        return element.type != null;
      });

      setMembers(dataFiltered);
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  };

  const getActionsByStatus = async () => {
    const data = await getMemberActionByStatus(id || "");
    if (data.success) {
      setActionsForStatus(data.data);
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  };

  const handleCheckboxChange = async (
    i: number,
    checked: boolean,
    type: string,
    item: string
  ) => {
    const copy = JSON.parse(JSON.stringify(actionsForStatus));
    if (type == "dev") {
      if (item == "pr") {
        copy.devActions[i].performApprovePr = checked;
      }

      if (item == "mt") {
        copy.devActions[i].performMaintence = checked;
      }
    } else {
      if (item == "sc") {
        copy.supActions[i].performScreening = checked;
      }
      if (item == "tt") {
        copy.supActions[i].performTest = checked;
      }
    }

    const data = await calculateMemberActionsChange(copy, type);
    if (data.success) {
      console.log(data.data);
      setActionsForStatus(data.data);
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  };

  const handlePercentageFieldChanged = (
    index: number,
    value: string,
    type: string,
    item: string
  ) => {
    const copy = JSON.parse(JSON.stringify(actionsForStatus));
    let onlyNumbers = value.replace(/[^\d.]/g, "");

    if (type == "dev") {
      if (item == "pr") {
        copy.devActions[index].prPercentage = onlyNumbers;
        copy.devActions[index].prManualChanged = true;
      }
      if (item == "mt") {
        copy.devActions[index].maintencePercentage = onlyNumbers;
        copy.devActions[index].maintenceManualChanged = true;
      }
    }

    if (type == "sup") {
      if (item == "sc") {
        copy.supActions[index].screeningPercentage = onlyNumbers;
        copy.supActions[index].screeningManualChanged = true;
      }

      if (item == "tt") {
        copy.supActions[index].testPercentage = onlyNumbers;
        copy.supActions[index].testManualChanged = true;
      }
    }

    setActionsForStatus(copy);
  };

  const handlePercentageChange = async (
    i: number,
    newPerc: string,
    type: string
  ) => {
    const copy = JSON.parse(JSON.stringify(actionsForStatus));

    if (type == "dev") {
      copy.devActions[i].prPercentage = newPerc;
    }

    if (type == "sup") {
      copy.supActions[i].screeningPercentage = newPerc;
    }

    const data = await calculateMemberActionsChange(copy, type);
    if (data.success) {
      console.log(data.data);
      setActionsForStatus(data.data);
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  };

  const fetchAllStatus = async () => {
    try {
      const data = await getAllStatus();
      if (data.success) {
        setAllStatus(data.data);
      } else {
        notify("Ocorreu um erro ao buscar os dados", { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const getStatus = async () => {
    try {
      const data = await detailStatus(id || "");
      if (data.success) {
        if (data.data && data.data.internalEmailsToNotify) {
          const emailsJoin = data.data.internalEmailsToNotify.join(";");
          setEmailsString(emailsJoin);
        }

        if (data.data && data.data.inertiaEmails) {
          const emailsJoin = data.data.inertiaEmails.join(";");
          setEmailsInerciaString(emailsJoin);
        }

        if (data.data && data.data.tasksAccumulationEmails) {
          const emailsJoin = data.data.tasksAccumulationEmails.join(";");
          setEmailsTasksAccumulationString(emailsJoin);
        }
        setStatus(data.data);
      } else {
        notify(data.msg, { type: "error" });
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleGoBack = () => {
    window.location.href = "/status";
  };

  const handleSaveButtonClick = () => {
    if (id == "new") {
      handleSaveTool();
    } else {
      handleUpdateTool();
    }
  };

  const handleUpdateTool = async () => {
    try {
      const data = await updateStatus(status);
      if (data.success) {
        notify("Status atualizado com sucesso", { type: "success" });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        const splitedErrors = data.msg.split(";");
        if (splitedErrors != null) {
          splitedErrors.forEach((element) => {
            if (element.length > 0) notify(element.trim(), { type: "error" });
          });
        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleSaveTool = async () => {
    try {
      const data = await createStatus(status);
      if (data.success) {
        notify("Satus salvo com sucesso", { type: "success" });
        setTimeout(() => {
          navigate(`/status/edit/${data.data.id}`);
        }, 1000);
      } else {
        const splitedErrors = data.msg.split(";");
        if (splitedErrors != null) {
          splitedErrors.forEach((element) => {
            if (element.length > 0) notify(element.trim(), { type: "error" });
          });
        }
      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const handleSaveActions = async () => {
    const data = await updateMembersActions(actionsForStatus);
    if (data.success) {
      console.log(data.data);
      setActionsForStatus(data.data);
      notify("Ações salvas com sucesso", { type: "success" });
    } else {
      notify("Ocorreu um erro ao buscar os dados", { type: "error" });
    }
  };

  //#endRegion Logic

  return (
    <div className="page-container">
      <div className="d-flex align-center justify-content-between w-100">
        <div className="title-and-subtitle">
          <Title>Status</Title>
          <SubTitle>Cadastro</SubTitle>
        </div>
        <div className="d-flex gap-2">
          <Button
            color="secondary"
            style={{ height: "44px" }}
            onClick={() => handleGoBack()}
          >
            Voltar
          </Button>
          <Button
            color="success"
            style={{ height: "44px" }}
            onClick={handleSaveButtonClick}
          >
            Salvar
          </Button>
        </div>
      </div>
      <div className="mt-5 mb-2">
        <Form>
          <Row className="mt-3">
            <Col md={3} lg={3}>
              <Label className="label theme-text-color">Nome</Label>
              <Input
                className="custom-input"
                type="text"
                placeholder="Nome do status"
                value={status?.name}
                onChange={(e) => setStatus({ ...status, name: e.target.value })}
              />
            </Col>
            <Col md={3} lg={3}>
              <Label className="label theme-text-color">Posição Kanban/Menu (Números)</Label>
              <Input
              className="custom-input"
                type="text"
                placeholder="Somente Números"
                value={status?.kanbanPosition}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (!isNaN(inputValue)) {
                    setStatus({
                      ...status,
                      kanbanPosition: parseInt(inputValue, 10) || 0,
                    });
                  } else {
                    setStatus({
                      ...status,
                      kanbanPosition: isNaN(status?.kanbanPosition)
                        ? 0
                        : status?.kanbanPosition,
                    });
                  }
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6} lg={6} className="mt-3">
              <Label className="label theme-text-color">
                Emails notificação interna (Separe com ";")
              </Label>
              <Input
              className="custom-input"
                type="text"
                placeholder="exemplo@gmail.com;exemplo2@gmail.com"
                value={emailsString}
                onChange={(e) => setEmailsString(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mt-3 d-flex align-items-center">
            <Col md={3} lg={3}>
              <Label className="theme-text-color">Emitir alerta de atenção de inércia após:</Label>
              <Input
              className="custom-input"
                type="select"
                name="select-hours"
                value={status?.sendAlertInTimes}
                onChange={(e) => {
                  setStatus({
                    ...status,
                    sendAlertInTimes: parseInt(e.target.value),
                  });
                }}
              >
                {
                  hoursList.map((hour)=> {return (<option value={hour.value}>{hour.label}</option>)})
                }
              </Input>
            </Col>
          </Row>
          <Col md={6} lg={6} className="mt-3">
            <Label className="label theme-text-color">
              Emails notificação inércia (Separe com ";")
            </Label>
            <Input
            className="custom-input"
              type="text"
              placeholder="exemplo@gmail.com;exemplo2@gmail.com"
              value={emailsInerciaString}
              onChange={(e) => setEmailsInerciaString(e.target.value)}
            />
          </Col>
          <span className="divider"></span>

          
          <Row className="mt-3 d-flex align-items-center">
          <Col md={3} lg={3}>
              <Label className="theme-text-color">Limite de tarefas acumuladas:</Label>
              <FaQuestionCircle
              className="pointer ms-1 mb-1"
              color="#0d6efd"
              data-tooltip-id="accumulation-tip"
              data-tooltip-content="Nesse campo você define o limite de tarefas nesse status. Se esse limite for ultrapassado, os emails configurados abaixo serão notificados. Se você não configurar esse campo ou se ele for configurado como zero, não serão enviados os emails"
              data-tooltip-place="right"
							/>
              <Input
              className="custom-input"
                type="number"
                name="maxAccumulatedTasks"
                value={status?.maxAccumulatedTasks}
                onChange={(e) => {
                  setStatus({
                    ...status,
                    maxAccumulatedTasks: parseInt(e.target.value),
                  });
                }}
              >
        
              </Input>
              
            </Col>
            
            <Col md={3} lg={3}>
              <Label className="theme-text-color">Emitir alerta por acúmulo de tarefas após:</Label>
              <Input
              className="custom-input"
                type="select"
                name="select-hours"
                value={status?.sendAccumulationAlertInTimes}
                onChange={(e) => {
                  setStatus({
                    ...status,
                    sendAccumulationAlertInTimes: parseInt(e.target.value),
                  });
                }}
              >
                {
                  hoursList.map((hour)=> {return (<option value={hour.value}>{hour.label}</option>)})
                }
              </Input>
            </Col>
          </Row>
          <Col md={6} lg={6} className="mt-3">
            <Label className="label theme-text-color">
              Emails notificação acúmulo de tarefas (Separe com ";")
            </Label>
            <Input
            className="custom-input"
              type="text"
              placeholder="exemplo@gmail.com;exemplo2@gmail.com"
              value={emailsTasksAccumulationString}
              onChange={(e) => setEmailsTasksAccumulationString(e.target.value)}
            />
          </Col>
          <span className="divider"></span>



          <p className="gray-text-subtitle mt-3">
            Configurações Gerais
            <FaQuestionCircle
              className="pointer ms-1 mb-1"
              color="#0d6efd"
              data-tooltip-id="conf-gerais-tip"
              data-tooltip-content="Importante configurar corretamente para um funcionamento adequado do sistema, pois essas configurações são fundamentais para determinar o comportamento associado a cada status. Elas definem aspectos cruciais, como quais estados acionam notificações por email, em qual estágio as tarefas são criadas e outras operações essenciais no fluxo de trabalho do sistema"
              data-tooltip-place="right"
							/>
          </p>


          <Row className="mt-3">
            <Col md={2} lg={2}>
              <FormGroup 
              check
              >
                <Label check
                  className="theme-text-color"
                  data-tooltip-id="notify-partners-tip"
                  data-tooltip-content="Ativar para enviar emails aos parceiros quando as tarefas mudam de status."
                  data-tooltip-place="right"
                >
                  
                  <Input
                    type="checkbox"
                    checked={status?.sendToPartner || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        sendToPartner: isChecked,
                      }));
                    }}
                  />{" "}
                  Notificar Parceiros
                </Label>
                
              </FormGroup>
            </Col>
            <Col md={2} lg={2}>
              <FormGroup check>
                <Label 
                className="theme-text-color"
                data-tooltip-id="initial-state-tip"
                data-tooltip-content="Fase inicial do fluxo, reservada para tarefas aprovadas na triagem"
                data-tooltip-place="right"
                check>
                  <Input
                    type="checkbox"
                    checked={status?.isInitialState || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        isInitialState: isChecked,
                      }));
                    }}
                  />{" "}
                  Etapa Inicial
                </Label>
              </FormGroup>
            </Col>

            <Col md={2} lg={2}>
              <FormGroup check>
                <Label 
                className="theme-text-color"
                data-tooltip-id="finish-state-tip"
                data-tooltip-content="Fase final do fluxo, reservada para tarefas solucionadas e publicadas."
                data-tooltip-place="right"
                check>
                  <Input
                    type="checkbox"
                    checked={status?.isFinishState || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        isFinishState: isChecked,
                      }));
                    }}
                  />{" "}
                  Última Etapa
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={2} lg={2}>
              <FormGroup check>
                <Label 
                className="theme-text-color"
                data-tooltip-id="test-state-tip"
                data-tooltip-content="Indica status exclusivo para tarefas em fase de teste."
                data-tooltip-place="right"
                check
                
                >
                  <Input
                    type="checkbox"
                    checked={status?.isTestState || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        isTestState: isChecked,
                      }));
                    }}
                  />{" "}
                  Etapa de Testes
                </Label>
              </FormGroup>
            </Col>
            <Col md={2} lg={2}>
              <FormGroup check>
                <Label 
                className="theme-text-color"
                data-tooltip-id="pre-test-tip"
                data-tooltip-content="Destinada a tarefas publicadas no ambiente de testes, aguardando testes."
                data-tooltip-place="right"
                check>
                  <Input
                    type="checkbox"
                    checked={status?.isPreTestState || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        isPreTestState: isChecked,
                      }));
                    }}
                  />{" "}
                  Etapa Pré-Teste
                </Label>
              </FormGroup>
            </Col>

            <Col md={2} lg={2}>
              <FormGroup check>
                <Label 
                className="theme-text-color"
                data-tooltip-id="screening-tip"
                data-tooltip-content="Status para triagem técnica das tarefas por um responsável do suporte."
                data-tooltip-place="right"
                check>
                  <Input
                    type="checkbox"
                    checked={status?.isScreeningState || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setStatus((prevStatus) => ({
                        ...prevStatus,
                        isScreeningState: isChecked,
                      }));
                    }}
                  />{" "}
                  Etapa Triagem
                </Label>
              </FormGroup>
            </Col>
          </Row>
          {!status?.isFinishState && (
            <div>
              <span className="divider"></span>
              <Row className="mt-3">
                <p  className="gray-text-subtitle">
                  Próxima Etapa/Status
                </p>
                {allStatus.map(
                  (s) =>
                    status?.id != s?.id && (
                      <Col md={2} lg={2}>
                        <FormGroup check key={s.id}>
                          <Label className="theme-text-color" check>
                            <Input
                              value={s.id}
                              type="checkbox"
                              checked={status?.nextStateId == s.id || false}
                              onChange={(s) => {
                                const isChecked = s.target.checked;
                                let selectedStatus;

                                if (isChecked) {
                                  selectedStatus = allStatus.find(
                                    (e) => e.id === s.target.value
                                  );
                                }

                                setStatus({
                                  ...status,
                                  nextStateId: selectedStatus?.id,
                                  nextStateName: selectedStatus?.name,
                                });
                              }}
                            />{" "}
                            {s.name}
                          </Label>
                        </FormGroup>
                      </Col>
                    )
                )}
              </Row>
            </div>
          )}

          <span className="divider"></span>
          <Row className="mt-3">
            <p  className="gray-text-subtitle">
              Status Predecessor
            </p>
            {allStatus.map(
              (s) =>
                status?.id != s?.id && (
                  <Col md={2} lg={2}>
                    <FormGroup check key={s.id}>
                      <Label className="theme-text-color" check>
                        <Input
                          value={s.id}
                          type="checkbox"
                          checked={status?.reproveStateId == s.id || false}
                          onChange={(s) => {
                            const isChecked = s.target.checked;
                            let selectedStatus;

                            if (isChecked) {
                              selectedStatus = allStatus.find(
                                (e) => e.id === s.target.value
                              );
                            }
                            setStatus({
                              ...status,
                              reproveStateId: selectedStatus?.id,
                              reproveStateName: selectedStatus?.name,
                            });
                          }}
                        />{" "}
                        {s.name}
                      </Label>
                    </FormGroup>
                  </Col>
                )
            )}
          </Row>
        </Form>

        {/* <Col md={6} lg={6} className="mt-3">
                  <Label for="status-reproved-task-select">
                    Ao ser reprovada, a tarefa irá para o seguinte status:
                  </Label>
                  <Input
                    id="status-reproved-task-select"
                    name="select"
                    type="select"
                    onChange={(s) => {
                      let selectedStatus = allStatus.find((e) => e.id === s.target.value);
                      console.log(selectedStatus?.name)
                      setStatus({
                        ...status,
                        reproveStateId: selectedStatus?.id,
                        reproveStateName: selectedStatus?.name
                      });
                    }}
                  >
                  <option selected key={status?.reproveStateId} value={status?.reproveStateId}>{status?.reproveStateName}</option>

                  {allStatus.map((s) => (
    
                    s.id != status?.reproveStateId && s.id != status?.id && 
                    <option key={s.id} value={s.id}>
                      {s.name}
                    </option>


                  ))} 


                  </Input>
                  </Col> */}
      </div>
      {actionsForStatus != null && actionsForStatus != undefined && (
        <div className="mb-3">
          <span className="divider mb-2"></span>
          <div className="d-flex align-items-center justify-content-between">
            <span className="gray-text-subtitle">Ações</span>
            <Button
              color="warning bold"
              style={{ color: "#2e2e2e" }}
              onClick={handleSaveActions}
            >
              Salvar Ações
            </Button>
          </div>
          <Card className="mt-3 custom-card-edit-status" style={{ padding: "1rem" }}>
            <span className="gray-text-subtitle">Desenvolvedores</span>
            {actionsForStatus.devActions?.map((dev: any, index: any) => {
              return (
                <Row
                  key={index}
                  className="d-flex align-items-center mb-1 rounded custom-row-edit-status"
                  style={{ padding: "1rem" }}
                >
                  <Col md={2}>
                    <span className="theme-text-color">
                      {dev.memberName.split(" ")[0]}
                    </span>
                  </Col>
                  <Col
                    md={2}
                    style={{
                      display:
                        id == "65a6e1a105018714654de447" ? "flex" : "none",
                    }}
                  >
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        checked={dev.performApprovePr || false}
                        onChange={(e) =>
                          handleCheckboxChange(
                            index,
                            e.target.checked,
                            "dev",
                            "pr"
                          )
                        }
                      />
                      <Label check>Aprova PR's</Label>
                    </FormGroup>
                  </Col>
                  <>
                    <Col
                      md={2}
                      style={{
                        display:
                          id == "65a6e1a105018714654de447" ? "flex" : "none",
                      }}
                    >
                      <Input
                        disabled={
                          !dev.performApprovePr != null && !dev.performApprovePr
                        }
                        type="text"
                        name="pr-percentage"
                        id="pr-percentage"
                        value={dev.prPercentage}
                        onChange={(e) =>
                          handlePercentageFieldChanged(
                            index,
                            e.target.value,
                            "dev",
                            "pr"
                          )
                        }
                        onBlur={(e) => {
                          const newPercentage = e.target.value;
                          handlePercentageChange(index, newPercentage, "dev");
                        }}
                      />
                    </Col>
                  </>
                  <Col md={2}>
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        checked={dev.performMaintence || false}
                        onChange={(e) =>
                          handleCheckboxChange(
                            index,
                            e.target.checked,
                            "dev",
                            "mt" //Maitence
                          )
                        }
                      />
                      <Label className="theme-text-color" check>Recebe tarefas</Label>
                    </FormGroup>
                  </Col>
                  <>
                    <Col md={2}>
                      <Input
                        disabled={
                          !dev.performMaintence != null && !dev.performMaintence
                        }
                        type="text"
                        name="pr-percentage"
                        id="pr-percentage"
                        value={dev.maintencePercentage}
                        onChange={(e) =>
                          handlePercentageFieldChanged(
                            index,
                            e.target.value,
                            "dev",
                            "mt"
                          )
                        }
                        onBlur={(e) => {
                          const newPercentage = e.target.value;
                          handlePercentageChange(index, newPercentage, "dev");
                        }}
                      />
                    </Col>
                  </>
                </Row>
              );
            })}
            <span className="divider"></span>
            <span className="gray-text-subtitle mt-3 mb-3">Suporte</span>
            {actionsForStatus.supActions?.map((sup: any, index: any) => {
              return (
                <Row
                  key={index}
                  className="d-flex align-items-center  mb-1 rounded custom-row-edit-status"
                  style={{ padding: "1rem" }}
                >
                  <Col md={2}>
                    <span className="theme-text-color">
                      {sup.memberName.split(" ")[0]}
                    </span>
                  </Col>
                  <Col
                    md={2}
                    style={{
                      display:
                        id == "65b14608bc1197c6408ed376" ? "flex" : "none",
                    }}
                  >
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        checked={sup.performScreening || false}
                        onChange={(e) =>
                          handleCheckboxChange(
                            index,
                            e.target.checked,
                            "sup",
                            "sc"
                          )
                        }
                      />
                      <Label className="theme-text-color"  check>Realiza Triagem</Label>
                    </FormGroup>
                  </Col>
                  <>
                    <Col
                      
                      md={2}
                      style={{
                        display:
                          id == "65b14608bc1197c6408ed376" ? "flex" : "none",
                      }}
                    >
                      <Input
                        disabled={
                          !sup.performScreening != null && !sup.performScreening
                        }
                        type="text"
                        name="pr-percentage"
                        id="pr-percentage"
                        value={sup.screeningPercentage}
                        onChange={(e) =>
                          handlePercentageFieldChanged(
                            index,
                            e.target.value,
                            "sup",
                            "sc"
                          )
                        }
                        onBlur={(e) => {
                          const newPercentage = e.target.value;
                          handlePercentageChange(index, newPercentage, "sup");
                        }}
                      />
                    </Col>
                  </>
                  <Col
                    md={2}
                    style={{
                      display:
                        id == "65a6e1ce05018714654de449" ? "flex" : "none",
                    }}
                  >
                    <FormGroup check inline>
                      <Input
                        type="checkbox"
                        checked={sup.performTest || false}
                        onChange={(e) =>
                          handleCheckboxChange(
                            index,
                            e.target.checked,
                            "sup",
                            "tt" //Maitence
                          )
                        }
                      />
                      <Label check>Realiza Testes</Label>
                    </FormGroup>
                  </Col>
                  <>
                    <Col
                      md={2}
                      style={{
                        display:
                          id == "65a6e1ce05018714654de449" ? "flex" : "none",
                      }}
                    >
                      <Input
                        disabled={!sup.performTest != null && !sup.performTest}
                        type="text"
                        name="pr-percentage"
                        id="pr-percentage"
                        value={sup.testPercentage}
                        onChange={(e) =>
                          handlePercentageFieldChanged(
                            index,
                            e.target.value,
                            "sup",
                            "tt"
                          )
                        }
                        onBlur={(e) => {
                          const newPercentage = e.target.value;
                          handlePercentageChange(index, newPercentage, "sup");
                        }}
                      />
                    </Col>
                  </>
                </Row>
              );
            })}
          </Card>
        </div>
      )}



    <Tooltip style={{width:"50%"}} id="conf-gerais-tip" opacity={0.9}/>
    <Tooltip style={{width:"50%"}} id="accumulation-tip" opacity={0.9}/>
    <Tooltip id="notify-partners-tip" opacity={0.7}/>
    <Tooltip id="test-state-tip" opacity={0.7}/>
    <Tooltip id="pre-test-tip" opacity={0.7}/>
    <Tooltip id="screening-tip" opacity={0.7}/>
    <Tooltip id="initial-state-tip" opacity={0.7}/>
    <Tooltip id="finish-state-tip"  opacity={0.7}/>



    </div>
  );
}

export default StatusEdit;
